export class UpdateSimInfoResponse {
  success: boolean;
}
